import { setSecureValue } from '@helpers';
import { identifyUser } from './identifyUser';
import { trackEvent } from './trackEvent';
import { setUserId } from './setUserId';
import { TRACKING_EVENTS } from '@services/tracking/config';
import { UserInfo } from '@services/tracking/types';

export const trackUserLoggedIn = (userInfo: UserInfo): void => {
  if (userInfo?.emailAddress) {
    setUserId(userInfo.emailAddress);
  }

  // Store session start time for duration calculation on logout
  setSecureValue('sessionStartTime', String(Date.now()));

  trackEvent(TRACKING_EVENTS.USER_LOGGED_IN, {
    email: userInfo?.emailAddress,
    company: userInfo?.companyProfile?.companyName,
  });
  identifyUser(userInfo);
};
